module.exports = __webpack_public_path__ + "static/img/bottom-spilt.e6e6571b.png";